import { render, staticRenderFns } from "./PagePart5_edit.vue?vue&type=template&id=0713db8e&scoped=true"
import script from "./PagePart5_edit.vue?vue&type=script&lang=js"
export * from "./PagePart5_edit.vue?vue&type=script&lang=js"
import style0 from "./PagePart5_edit.vue?vue&type=style&index=0&id=0713db8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713db8e",
  null
  
)

export default component.exports